module.exports = __webpack_public_path__ + "3f2cbb6eb1626b6bf6188319eceac8f1.png";